export enum EnumRecipientsType {
  BC = 1,
  BAC = 2,
  Admin = 3,
  Client = 4,
}
